import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import './ModalThirdParty.scss'

import { GOOGLE_FAQ_URL, GOOGLE_PRIVACY_URL } from 'Constants/index'
import { updateThirdPartyCallback } from 'Pages/Campaign/recoil/callbacks/callbackEditBee'
import { modalThirdPartyState } from 'Pages/Campaign/recoil/state/modals'

export const ModalThirdParty = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalThirdPartyState)

  const updateThirdPartyResourceAlertState = useRecoilCallback(
    updateThirdPartyCallback,
    []
  )

  return (
    <Modal
      show={show}
      showClose={false}
      closeOnOverlayClick={false}
      className='c-message-third-party'
      data-mu-test='modal-message-third-party'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalForThirdPartyResourcesTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage(
          {
            id: 'Load.Bee.ModalForThirdPartyResourcesContentIntl'
          },
          {
            faq: (content) => (
              <a
                key='google-key-faq'
                href={GOOGLE_FAQ_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='textlink-highlight test-warningGoogleFonts'
              >
                {content}
              </a>
            ),
            privacy: (content) => (
              <a
                key='google-key-privacy'
                href={GOOGLE_PRIVACY_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='textlink-highlight test-warningGoogleFonts'
              >
                {content}
              </a>
            )
          }
        )}
      </ModalBody>
      <ModalFoot>
        <Button
          data-mu-test='button-message-third-party'
          onClick={updateThirdPartyResourceAlertState}
          kind='primary'
        >
          {intl.formatMessage({
            id: 'Load.Bee.ModalForThirdPartyResourcesButton'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
